import React, {useEffect} from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { IoIosArrowForward } from "react-icons/io";
import { FiEdit } from "react-icons/fi";
import { FaCameraRetro } from "react-icons/fa";
import { FaImages } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";
import AOS from 'aos';
function Vision() {
  useEffect(() => {
    AOS.init({
      duration: 1200,  // Global duration of animations in milliseconds
    });
  }, []);
  return (
    <Container>
      <h1 className='shine' data-aos="fade-up">Production Process</h1>
      
      <Wrap>
        <Slot data-aos="zoom-in">
          <div>
            <FiEdit size={40} />
          </div>
          <h2>Pre - Production</h2>
          <p>Location scouting and permissions</p>
          <p>Concept development</p>
          <p>Script Writing</p>
          <p>Story Boarding</p>
          <p>Set design</p>
          <p>Costume design</p>
        </Slot>
        <IoIosArrowForward className="desktop-icon" size={40} />
        <IoIosArrowDown className="mobile-icon" size={40} />
        <Slot data-aos="zoom-in">
          <div>
            <FaCameraRetro  size={40} />
          </div>
          <h2>Production</h2>
          <p>Film and video production</p>
          <p>Film and video direction</p>
          <p>Aerial Cinematography</p>
          <p>Sound recording</p>
        </Slot>
        <IoIosArrowForward className="desktop-icon" size={40} />
        <IoIosArrowDown className="mobile-icon" size={40} />
        <Slot data-aos="zoom-in">
          <div>
            <FaImages size={40} />
          </div>
          <h2>Post - Production</h2>
          <p>Video editing</p>
          <p>Color grading</p>
          <p>Audio composition</p>
          <p>Visual effects</p>
          <p>Dubbing & Voiceover</p>
          <p>Subtitles and transition</p>
        </Slot>
      </Wrap>
    </Container>
  );
}
const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  padding: 50px 0;

  @media only screen and (max-width: 1200px) {
    padding: 20px 0;
  }

  h1 {
    font-size: 32px;
    margin-top:5vw;
    text-transform: uppercase;
    color:white;
  }
`;

const Wrap = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  padding: 50px 0;

  .desktop-icon {
    display: block;
    color: var(--secondary-color);

    @media only screen and (max-width: 1200px) {
      display: none;
    }
  }

  .mobile-icon {
    display: none;
    color: var(--secondary-color);

    @media only screen and (max-width: 1200px) {
      display: block;
    }
  }
`;

const Slot = styled.div`
  width: 25%;
  color:white;
  height: 340px;
  display: flex;
  flex-direction: column;
  padding: 20px;
  align-items: center;
 background: linear-gradient(#000, var(--secondary-background-color))
      padding-box,
    linear-gradient(
        145deg,
        transparent 35%,
        var(--secondary-color),
        var(--secondary-color)
      )
      border-box;
  border: 2px solid transparent;
  border-radius: 16px;
  margin: 20px;
  box-shadow: 0px 187px 75px rgba(0, 0, 0, 0.01),
    0px 105px 63px rgba(0, 0, 0, 0.05), 0px 47px 47px rgba(0, 0, 0, 0.09),
    0px 12px 26px rgba(0, 0, 0, 0.1), 0px 0px 0px rgba(0, 0, 0, 0.1);

  @media only screen and (max-width: 1200px) {
    width: 94%;
    height: 320px;
    padding: 25px;
    margin-bottom: 10px;
    margin: 10px 0;
  }

  div {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    @media only screen and (max-width: 1200px) {
      width: 60px;
      height: 60px;
    }
  }

  h2 {
    margin: 20px 0 15px 0;

    @media only screen and (max-width: 1200px) {
      font-size: 23px;
    }
  }
  p {
    line-height: 1.6rem;
    text-align: center;
    font-size: 15px;

    @media only screen and (max-width: 1200px) {
      font-size: 13px;
      text-align: center;
    }
  }

  .icon_arrow {
    font-size: 30px;
  }

  .icons_head{
    color: black;
  }
`;
export default Vision;
